module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/15ItcOA/tc-custom/9781616896836.jpg?1728851686572",
      "alt": "This image is the cover for the book Raptors"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Raptors\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("This delightful and dramatic portrait collection reveals birds of prey as we never experience them: intimate and up close.")])]), _c('p', [_vm._v(" Photographed in Traer Scott’s signature style, these fascinating hunters reveals their enigmatic beauty and grace. Seventy spectacular color images present twenty-five different species, from the familiar to the exotic and endangered: hawks, owls, falcons, a bald eagle, kestrels, a Mississippi Kite, a turkey vulture, and more. Joining their elders are a fluffy baby vulture and adorable baby and juvenile great horned owls. ")]), _c('p', [_vm._v(" The birds in this remarkable collection emerge as personalities, not just types: wise and quizzical, serene, and fiercely self-possessed. A personal introduction describes Scott’s process and connection to the birds, and captions detail the characteristics and habits of these incredible winged creatures. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Traer Scott\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Traer Scott is the author of eight books of photographs. She lives in Providence, Rhode Island.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Princeton Architectural Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0